import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {Box} from '@mui/material';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../../api/axios';
import {apiBaseUrl} from '../../../api/urls';
import {saveFile} from '../../../utils/file';
import {CloseSnackbarButton} from '../../common/CloseSnackbarButton';
import ExportFieldForm from '../../common/ExportFieldForm';
import ModalFixed from '../../common/ModalFixed';
import SnackbarMessages from '../../common/SnackbarMessages';

interface Props {
  //reportDate: string | undefined;
  reportType: string;
  shiftId: number | undefined;
}

interface Params {
  export: string;
  fields: string[];
  //date_end: string | undefined;
  report_type: string;
  shift_id?: number;
}

const ShaftClearanceMinersExportExcel = ({
  //reportDate,
  reportType,
  shiftId,
}: Props) => {
  const {enqueueSnackbar, closeSnackbar} = useSnackbar();
  const [isFetching, setIsFetching] = useState(false);

  const [isOpened, setIsOpened] = useState(false);

  const reportDateString = new Date().toISOString().slice(0, 10);

  const exportFieldOptions = [
    {field: 'first_name', label: 'First Name', hidden: false},
    {field: 'last_name', label: 'Last Name', hidden: false},
    {field: 'name', label: 'Name', hidden: false},
    {field: 'network_id', label: 'Network ID', hidden: false},
    {field: 'type', label: 'Type', hidden: false},
    {field: 'timestamp', label: 'Last Reported Timestamp', hidden: false},
    {field: 'date', label: 'Time of Data Collection', hidden: false},
    {field: 'shift', label: 'Shift', hidden: false},
    {field: 'section', label: 'Section', hidden: false},
    {field: 'position', label: 'Position', hidden: false},
    {field: 'latitude', label: 'Latitude', hidden: false},
    {field: 'longitude', label: 'Longitude', hidden: false},
    {field: 'strongest_node', label: 'Strongest Node', hidden: false},
    {field: 'job_type', label: 'Job Type', hidden: false},
  ];

  const getMinerReportName = () => {
    switch (reportType) {
      case 'out':
        return shiftId
          ? `DailyEmployeeOut-Shift${shiftId}-${reportDateString}`
          : `DailyEmployeeOut-${reportDateString}`;
      case 'not-out':
        return shiftId
          ? `DailyEmployeeNotOut-Shift${shiftId}-${reportDateString}`
          : `DailyEmployeeNotOut-${reportDateString}`;
      case 'weekly':
        return `WeeklyMinerOut-${reportDateString}`;
      case 'monthly':
        return `MonthlyMinerOut-${reportDateString}`;
      case 'quarterly':
        return `QuarterlyMinerOut-${reportDateString}`;
      case 'yearly':
        return `YearlyMinerOut-${reportDateString}`;
      default:
        return 'Shaft Clearance Employee Report';
    }
  };

  const checkFields = () => {
    setIsOpened(true);
  };

  const fetchData = async (fields: string[]) => {
    setIsOpened(false);
    setIsFetching(true);

    try {
      const params: Params = {
        export: 'excel',
        fields,
        //date_end: reportDate,
        report_type: reportType,
      };

      if (shiftId) {
        params.shift_id = shiftId;
      }

      const resp = await API.get(`${apiBaseUrl}/shaft-clearance/miners`, {
        params,
        responseType: 'blob',
      });
      saveFile(resp.data, getMinerReportName());
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, "STRA_d523fb79");
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: (key) => (
          <CloseSnackbarButton onClick={() => closeSnackbar(key)} />
        ),
      });
    }
    setIsFetching(false);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" justifyContent="end">
        <FileDownloadIcon
          onClick={() => {
            if (!['out', 'not-out'].includes(reportType)) {
              fetchData([]);
            } else {
              checkFields();
            }
          }}
        ></FileDownloadIcon>
      </Box>
      <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
        <Box
          display="flex"
          flexDirection="column"
          position="relative"
          gap={3}
          p={3}
        >
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" alignItems="center" width="100%" gap={1.5}>
              <ExportFieldForm
                exportFields={exportFieldOptions}
                onChange={fetchData}
                close={() => setIsOpened(false)}
                loading={isFetching}
                columns={3}
              ></ExportFieldForm>
            </Box>
          </Box>
        </Box>
      </ModalFixed>
    </Box>
  );
};

export default ShaftClearanceMinersExportExcel;
